



























import { Component, Vue, Mixins } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import { priUrlReg } from '@/apps/open/constants'
import Button from '@components/Button'
import { ElForm } from 'element-ui/types/form'
import { getMsgSubscribe, setMsgSubscribe } from '@/apps/open/services/app'

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Callback extends Vue {
  form = {
    cb_domain: '',
    file_hook: '',
    group_hook: ''
  }

  loading: boolean = false

  $refs!: {
    form: ElForm
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调域名', trigger: ['blur', 'change'] } : { type: 'url', message: '请输入正确的回调域名', trigger: ['blur', 'change'] }
    return {
      cb_domain: [
        { required: true, message: '请填写回调域名', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] },
        urlRule
      ],
      file_hook: [
        { required: true, message: '请填写文档变更通知', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ],
      group_hook: [
        { required: true, message: '请填写团队变更通知', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] }
      ]
    }
  }

  isEdit: boolean = false

  get appId () {
    return this.$route.params.id
  }

  mounted () {
    this.getCallbackInfo()
  }

  saveCallbackConfig () {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          callback_url: this.form.cb_domain,
          file_hook: this.form.file_hook,
          group_hook: this.form.group_hook
        }
        const res = await setMsgSubscribe(this.appId, params)
        if (res.data.result === 'ok') {
          this.$message.success('更新成功')
        }
      }
    })
  }

  async getCallbackInfo () {
    const res = await getMsgSubscribe(this.appId)
    if (res.data.result === 0) {
      const info = res.data.object
      this.form = {
        cb_domain: info.callback_url,
        file_hook: info.file_hook,
        group_hook: info.group_hook
      }
    }
  }
}
